import { z } from "zod";

export const saveCaseWithTaskSchema = z.object({
    caseTaskUUID: z.string(),
    tag: z.string(),
    note: z.string(),
});
